<template>
  <bronze-token-checked v-if="type === bronze"></bronze-token-checked>
  <silver-token-checked v-else-if="type === silver"></silver-token-checked>
  <orange-token-checked v-else-if="type === orange"></orange-token-checked>
</template>

<script>
import {BRONZE, SILVER, ORANGE} from '../../../source/constants/tokens';

import BronzeTokenChecked from './BronzeTokenChecked';
import OrangeTokenChecked from './OrangeTokenChecked';
import SilverTokenChecked from './SilverTokenChecked';

export default {
  props: {
    type: String
  },
  data() {
    return {
      bronze: BRONZE,
      silver: SILVER,
      orange: ORANGE
    };
  },
  components: {BronzeTokenChecked, OrangeTokenChecked, SilverTokenChecked}
};
</script>
